import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
const Login = () => import('@/components/Login')
const LoginToken = () => import('@/components/LoginToken')
const SalesOrderList = () => import('@/components/SalesOrderList')
const SalesOrderDetails = () => import('@/components/SalesOrderDetails')
const ShipmentList = () => import('@/components/ShipmentList')
const ShipmentDetails = () => import('@/components/ShipmentDetails')
const ShipmentEmail = () => import('@/components/ShipmentEmail')
const TicketList = () => import('@/components/TicketList')
const TicketDetails = () => import('@/components/TicketDetails')
const TicketCreation = () => import('@/components/TicketCreation')
const CategoryList = () => import('@/components/CategoryList')
const ProductList = () => import('@/components/ProductList')
const ProductDetails = () => import('@/components/ProductDetails')
const MarkupList = () => import('@/components/MarkupList')
const MarkupDetails = () => import('@/components/MarkupDetails')
const SupplierList = () => import('@/components/SupplierList')
const SupplierDetails = () => import('@/components/SupplierDetails')
const AdminList = () => import('@/components/AdminList')
const AdminDetails = () => import('@/components/AdminDetails')
const MyProfile = () => import('@/components/MyProfile')
const MyPassword = () => import('@/components/MyPassword')
const TransactionList = () => import('@/components/TransactionList')
const HelpSales = () => import('@/components/HelpSales')
const HelpTicket = () => import('@/components/HelpTicket')
const HelpProduct = () => import('@/components/HelpProduct')
const HelpMarkup = () => import('@/components/HelpMarkup')
const HelpSupplier = () => import('@/components/HelpSupplier')
const HelpMyStore = () => import('@/components/HelpMyStore')
const HelpMyAccount = () => import('@/components/HelpMyAccount')

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  console.log(to)
  next('/login?next=' + to.fullPath)
}

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition && !to.matched.some(m => m.meta.scrollToTop)) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}

    if (to.matched.some(m => m.meta.scrollToTop)) {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      console.log('scroll to top')
      position.x = 0
      position.y = 0
    }

    return position
  }
}

export default new Router({
  scrollBehavior,
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login/token/:loginToken',
      name: 'LoginToken',
      props: true,
      component: LoginToken
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Home',
      component: TicketList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/products',
      name: 'ProductList',
      component: ProductList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/product',
      name: 'AddProduct',
      component: ProductDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/product/:productId',
      name: 'ProductDetails',
      props: true,
      component: ProductDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/categories',
      name: 'CategoryList',
      component: CategoryList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/categories/:parentId',
      name: 'CategoryListByParentId',
      props: true,
      component: CategoryList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/markups',
      name: 'MarkupList',
      component: MarkupList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/markup/:productMarkupId',
      name: 'MarkupDetails',
      props: true,
      component: MarkupDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/suppliers',
      name: 'SupplierList',
      component: SupplierList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/supplier',
      name: 'AddSupplier',
      component: SupplierDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/supplier/:supplierId',
      name: 'SupplierDetails',
      props: true,
      component: SupplierDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/orders',
      name: 'SalesOrderList',
      component: SalesOrderList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/orders/:status',
      name: 'SalesOrderListByStatus',
      props: true,
      component: SalesOrderList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/order/:salesOrderNo',
      name: 'SalesOrderDetails',
      props: true,
      component: SalesOrderDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/shipments/:salesOrderNo',
      name: 'ShipmentList',
      props: true,
      component: ShipmentList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/shipment/email/:deliveryOrderNo',
      name: 'ShipmentEmail',
      props: true,
      component: ShipmentEmail,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/shipment/:deliveryOrderNo',
      name: 'ShipmentDetails',
      props: true,
      component: ShipmentDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/ticket',
      name: 'TicketCreation',
      component: TicketCreation,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tickets',
      name: 'TicketList',
      component: TicketList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tickets/:status',
      name: 'TicketListByStatus',
      props: true,
      component: TicketList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/ticket/:ticketId',
      name: 'TicketDetails',
      props: true,
      component: TicketDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/admins',
      name: 'AdminList',
      component: AdminList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/admin',
      name: 'AddAdmin',
      component: AdminDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/admin/:adminId',
      name: 'AdminDetails',
      props: true,
      component: AdminDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/store/transactions',
      name: 'TransactionList',
      component: TransactionList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/me/profile',
      name: 'MyProfile',
      component: MyProfile,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/me/password',
      name: 'MyPassword',
      component: MyPassword,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/help/sales',
      name: 'HelpSales',
      component: HelpSales,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/help/tickets',
      name: 'HelpTicket',
      component: HelpTicket,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/help/products',
      name: 'HelpProduct',
      component: HelpProduct,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/help/markup',
      name: 'HelpMarkup',
      component: HelpMarkup,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/help/supplier',
      name: 'HelpSupplier',
      component: HelpSupplier,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/help/my_store',
      name: 'HelpMyStore',
      component: HelpMyStore,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/help/my_account',
      name: 'HelpMyAccount',
      component: HelpMyAccount,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    }
    /*
    {
      path: '/customers',
      name: 'CustomerList',
      component: CustomerList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/customer',
      name: 'AddCustomer',
      component: CustomerDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/customer/:customerId',
      name: 'CustomerDetails',
      props: true,
      component: CustomerDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/banners',
      name: 'BannerList',
      component: BannerList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/banner',
      name: 'AddBanner',
      component: BannerDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/banner/:bannerId',
      name: 'BannerDetails',
      props: true,
      component: BannerDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    }
*/
  ]
})
